<template>
    <div>
        <el-form
            ref="addform"
            :inline="true"
            :model="addform"
            :rules="addrules"
            label-width="120px"
        >
        <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
                <template slot="title">
                    <span class="col_title">主要</span>
                </template>
                <el-form-item label="客户名称" prop="cname">
                    <el-input maxlength="20" v-model="addform.cname" style="width: 240px" />
                </el-form-item>
                <el-form-item label="电话">
                    <el-input
                        v-model="addform.phone"
                        style="width: 240px"
                        @change="setAccount"
                    />
                </el-form-item>
                <el-form-item label="账号">
                    <el-input
                        v-model="addform.username"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-form-item label="账号状态">
                    <el-radio v-model="addform.valid" label="1">开通</el-radio>
                    <el-radio v-model="addform.valid" label="0">禁用</el-radio>
                </el-form-item>
            </el-collapse-item>
            <el-collapse-item name="2">
                <template slot="title">
                    <span class="col_title">更多选项</span>
                </template>
                <el-form-item label="客户类别">
                    <el-select
                        ref="selectReport"
                        v-model="addform.typeName"
                        placeholder="请选择客户类别"
                        style="width: 240px"
                    >
                        <el-option
                            :value="addform.category"
                            :label="addform.typeName"
                            style="
                                width: 240px;
                                height: 200px;
                                overflow: auto;
                                background-color: #fff;
                            "
                        >
                            <el-tree
                                :data="all"
                                :props="defaultProps"
                                node-key="id"
                                :default-expanded-keys="[0]"
                                @node-click="handleNodeClick"
                            />
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="客户等级">
                    <el-select
                        v-model="addform.rank"
                        placeholder="请选择客户等级"
                        filterable
                        allow-create
                        default-first-option
                        style="width: 240px"
                    >
                        <el-option
                            v-for="item in levels"
                            :key="item.value"
                            :label="item.label"
                            :value="item.label"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="签约时间">
                    <el-date-picker
                        v-model="addform.signdate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 240px"
                        :editable="false"
                        @change="dataPick"
                    />
                </el-form-item>
                <el-form-item label="期初欠款(元)">
                    <el-input v-model="addform.beginBill" type="number" :min="0" style="width: 240px" @input="$common.checkMoney($event,addform,'beginBill')"/>
                </el-form-item>
                <el-input
                    v-model="addform.remark"
                    type="textarea"
                    :rows="2"
                    placeholder="添加备注信息"
                    maxlength="150"
                    show-word-limit
                    style="width: 80%; padding-left:40px;margin-bottom:22px"
                />
                <el-form-item label="开户名称">
                    <el-input maxlength="100" v-model="addform.invoice" style="width: 240px" />
                </el-form-item>
                <el-form-item label="纳税人识别号">
                    <el-input maxlength="50" v-model="addform.taxIdentification" style="width: 240px" />
                </el-form-item>
                <el-form-item label="地址">
                    <el-input maxlength="80" v-model="addform.invoiceaddress" style="width: 240px" />
                </el-form-item>
                <el-form-item label="电话">
                    <el-input maxlength="20" v-model="addform.invoicephone" style="width: 240px" />
                </el-form-item>
                <el-form-item label="开户银行">
                    <el-input maxlength="50" v-model="addform.bankname" style="width: 240px" />
                </el-form-item>
                <el-form-item label="银行账号">
                    <el-input
                        v-model="addform.bankaccountnumber"
                        maxlength="50"
                        style="width: 240px"
                    />
                </el-form-item>
                <el-table
                    :data="addform.list"
                    border
                    style="width: 100%"
                    max-height="280px"
                    :header-cell-style="{ background: '#eef1f6' }"
                >
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                icon="el-icon-plus"
                                circle
                                @click="additem(scope.$index)"
                            />
                            <el-button
                                size="mini"
                                icon="el-icon-minus"
                                type="danger"
                                circle
                                @click="delitem(scope.$index)"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column label="联系人">
                        <template slot-scope="scope">
                            <el-input maxlength="30" v-model="scope.row.name" size="small" />
                        </template>
                    </el-table-column>
                    <el-table-column label="手机">
                        <template slot-scope="scope">
                            <el-input maxlength="20" v-model="scope.row.phone" size="small" />
                        </template>
                    </el-table-column>
                    <el-table-column label="QQ">
                        <template slot-scope="scope">
                            <el-input maxlength="20" v-model="scope.row.qq" size="small" />
                        </template>
                    </el-table-column>
                    <el-table-column label="微信">
                        <template slot-scope="scope">
                            <el-input maxlength="20" v-model="scope.row.wechat" size="small" />
                        </template>
                    </el-table-column>
                    <el-table-column label="货运" v-if="$global.useinstall!=1">
                        <template slot-scope="scope">
                            <!-- <el-input maxlength="30" v-model="scope.row.transport" size="small" /> -->
                            <el-select v-model="scope.row.transport" filterable allow-create value-key="id">
                                <el-option v-for="item in transList" :key="item.id" :label="item.label" :value="item"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系地址" width="240">
                        <template slot-scope="scope">
                            <el-cascader
                                ref="district2"
                                v-model="scope.row.label"
                                size="mini"
                                :options="options_"
                                placeholder="省市区"
                                style="width: 100%"
                                @change="handleChange(scope.row,2)"
                            />
                            <el-input
                                v-model="scope.row.address"
                                size="small"
                                maxlength="50"
                                placeholder="详细地址"
                                style="width: 100%"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column label="是否默认" width="108">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.main"
                                :active-value="1"
                                :inactive-value="0"
                                @change="mainContact(scope.row)"
                            />
                        </template>
                    </el-table-column>
                </el-table>
                <el-table
                :data="showList"
                border
                style="width: 100%;margin-top:20px"
                max-height="280px"
                :header-cell-style="{ background: '#eef1f6' }" 
                v-if="$global.useinstall==1&&false">
                <el-table-column align="center" width="120">
                    <template #header>
                        <span style="padding-right:4px">操作</span>
                        <el-button
                            size="mini"
                            icon="el-icon-plus"
                            circle
                            @click="addRow()"
                        />
                    </template>
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            icon="el-icon-minus"
                            type="danger"
                            circle
                            @click="removeRow(scope.$index)"
                        />
                        <el-button
                            size="mini"
                            icon="el-icon-edit"
                            type="primary"
                            circle
                            @click="editRow(scope.$index)"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="安装地区" prop="label">
                    <template slot-scope="{row}">
                        <div>{{row.district.join("")}}</div>
                    </template>
                </el-table-column>
                <el-table-column  label="详细地址" prop="address">
                </el-table-column>
                <el-table-column  label="默认项">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.main"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#409EFF"
                            @change='mainChange($event,scope.$index)'
                            inactive-color="#DCDFE6">
                        </el-switch>
                    </template>
                </el-table-column>
                </el-table>
                <el-pagination
                v-if="totalPage>10"
                style="padding-top:20px"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="10"
                background
                layout="prev, pager, next"
                :total="totalPage">
                </el-pagination>
            </el-collapse-item>
        </el-collapse>
    </el-form>
    <el-dialog
        :visible.sync="dialogFormVisible"
        append-to-body
        width="60%"
        @close="closeDialog"
    >
        <template slot="title">
            <span style="padding-right:10px">{{editIndex==-1?'新增':'编辑'}}安装地址</span>
            <el-checkbox v-if="editIndex==-1" v-model="continuous" label="连续添加"/>
        </template>
        <el-form>
            <el-form-item label="安装地区" prop="label">
                <el-cascader
                    ref="district"
                    v-model="editForm.label"
                    :options="options_"
                    placeholder="省市区"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input
                    v-model="editForm.address"
                    maxlength="50"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="默认项" prop="main" v-if="editIndex==-1">
                <el-switch
                    v-model="editForm.main"
                    :active-value="1"
                    :inactive-value="0"
                    >
                </el-switch>
            </el-form-item>
            <div style="text-align:right">
                <el-button type="primary" @click="sure()">确定</el-button>
                <el-button @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-form>
        
    </el-dialog>
    </div>
</template>

<script>
import { regionData,CodeToText } from "element-china-area-data";

export default {
    props: {},
    data() {
        return {
            continuous:false,
            activeNames: ['1'],
            placeDialog: false,
            options: [],
            addrules: {
                cnumber: [
                    {
                        required: true,
                        message: "请输入客户编号",
                    },
                    {
                        min: 1,
                        max: 25,
                        message: "长度为 1-25 个字符",
                    },
                ],
                cname: [
                    {
                        required: true,
                        message: "请输入客户名称",
                        trigger: "blur",
                    },
                    {
                        max: 20,
                        message: "不超过20个字符",
                        trigger: "blur",
                    },
                ],
            },
            addform: {
                cnumber: "",
                cname: "",
                category: "",
                phone: "",
                rank: "",
                signdate: "",
                start: "",
                end: "",
                beginBill: 0,
                company: "",
                saleName: "",
                username: "",
                password: "",
                valid: "0",
                invoice: "",
                taxIdentification: "",
                address: "",
                invoiceaddress: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
                list: [
                    {
                        index: 1,
                        name: "",
                        tel: "",
                        phone: "",
                        qq: "",
                        wechat: "",
                        transport: "",
                        label: [],
                        address: "",
                        main: "",
                    },
                ],
                workAddressList:[],
                contacts: "",
                remark: "",
            },
            formLabelWidth: "120px",
            levels: [],
            options_: regionData,
            all: [],
            defaultProps: {
                children: "children",
                label: "label",
                id: "1",
            },
            transList:[],
            editIndex:-1,
            editForm:{},
            dialogFormVisible:false,
            currentPage:1,
            totalPage:10,
            showList:[],
        };
    },
    created(){
        this.$api.getCustomerRanksSetting({}).then((res)=>{
            let data = res.data.data;
            this.levels = [];
            if(data!=null&&data.length>0){
                let index = 1;
                data.forEach(e=>{
                    this.levels.push({
                        value:index,
                        label:e,
                    })
                    index++;
                })
            }
        })
        this.$api.getInfoPostSingle('/mobile/customer/listTransport',{limit:-1}).then(res=>{
            if(res.data.code==1){
                res.data.data.forEach(e=>{
                    let obj = {
                        label:e.name+e.phone+e.district.join(''),
                        id:e.id,
                    }
                    this.transList.push(obj);
                })
            }
        }) 
    },
    mounted() {
        this.getType();
    },
    methods: {
        handleCurrentChange(e){
            this.showList = null;
            let key = (e-1)*10;
            this.showList = this.addform.workAddressList.slice(key,key+10);
        },
        mainChange(e,key){
            if(e==1){
                this.addform.workAddressList.forEach((e,index)=>{
                    if(key==index){
                        e.main = 1;
                    }else{
                        e.main = 0;
                    }
                })
            }
        },
        addRow(){
            this.editForm = {
                main:0,
                district:[],
                label:'',
                address:'',
            }
            this.editIndex = -1;
            this.dialogFormVisible = true;
        },
        editRow(index){
            let zindex = (this.currentPage-1)*10 +index;
            let item = this.addform.workAddressList[zindex];
            if(item){
                this.editForm = {
                    main:item.main,
                    district:[],
                    label:item.label,
                    address:item.address,
                }
                this.editIndex = zindex;
                this.dialogFormVisible = true;
            }
        },
        sure(){
            if(this.editForm.label.length<1){
                this.$message.error('没有选择安装地址');
                return;
            }
            if(this.editIndex==-1){
                this.editForm.district = [];
                this.editForm.district.push(CodeToText[this.editForm.label[0]]);
                this.editForm.district.push(CodeToText[this.editForm.label[1]]);
                this.editForm.district.push(CodeToText[this.editForm.label[2]]);
                if(this.editForm.main==1){
                    this.addform.workAddressList.forEach(e=>{
                        e.main = 0;
                    })
                }
                this.addform.workAddressList.push(this.editForm);
                if(this.showList.length<10){
                    this.showList.push(this.editForm);
                }
                this.totalPage = this.addform.workAddressList.length;
                this.$message.success('操作成功');
                if(this.continuous){
                    this.editForm = {
                        main:0,
                        district:[],
                        label:'',
                        address:'',
                    }
                }else{
                    this.dialogFormVisible = false;
                }
            }else{
                let item = this.addform.workAddressList[this.editIndex];
                item.district = [];
                item.district.push(CodeToText[this.editForm.label[0]]);
                item.district.push(CodeToText[this.editForm.label[1]]);
                item.district.push(CodeToText[this.editForm.label[2]]);
                item.label = this.editForm.label;
                item.address = this.editForm.address;
                this.dialogFormVisible = false;
            }
        },
        closeDialog(){
            this.dialogFormVisible = false;
            this.editIndex = -1;
            this.editForm = {};
        },
        removeRow(index){
            this.showList.splice(index,1);
            let zindex = (this.currentPage-1)*10 +index;
            this.addform.workAddressList.splice(zindex,1);
            this.totalPage = this.addform.workAddressList.length;
            this.handleCurrentChange(this.currentPage);
        },
        init(){
            if(this.addform.company==''){
                this.getCompany();
                this.getCode();
            } 
        },
        getCompany() {
            this.$api.getInfo({}).then((res) => {
                if (res.data.code == 1) {
                    this.addform.company = res.data.data.name;
                    this.addform.saleName = localStorage.getItem("name");
                    this.addform.emp = localStorage.getItem("userid");
                }
            });
        },
        getCode() {
            this.$api.customergetCNumber({}).then((res) => {
                if (res.data.code == 1) {
                    this.addform.cnumber = res.data.data;
                }
            });
        },
        getType() {
            this.$api.customergetCustomerClassify({}).then((res) => {
                if (res.data.code == 1) {
                    this.options = res.data.data;
                    this.all = [];
                    var all = {};
                    all.children = this.options;
                    all.id = 0;
                    all.label = "全部";
                    all.parent = -1;
                    this.all.push(all);
                }
            });
        },
        handleNodeClick(node) {
            this.addform.category = node.id;
            this.addform.typeName = node.label;
            this.$refs.selectReport.blur();
        },
        handleChange(value,key) {
            this.$nextTick(() => {
                let checkedNodes = null;
                if(key==1){
                    checkedNodes = this.$refs.district1.getCheckedNodes();
                }else if(key==2){
                    checkedNodes = this.$refs.district2.getCheckedNodes();
                }
                if(checkedNodes.length>0){
                    value.district = checkedNodes[0].pathLabels.toString();
                }
            });
        },
        additem(index) {
            this.addform.list.splice(index + 1, 0, {
                index: 0,
                name: "",
                tel: "",
                phone: "",
                qq: "",
                wechat: "",
                transport: "",
                label: [],
                address: "",
                main: "",
            });
            for (let i = 0; i < this.addform.list.length; i++) {
                this.addform.list[i].index = i + 1;
            }
        },
        delitem(index) {
            if (this.addform.list.length > 1) {
                this.addform.list.splice(index, 1);
            } else {
                this.addform.list.splice(index, 1, {
                    index: 1,
                    name: "",
                    tel: "",
                    phone: "",
                    qq: "",
                    wechat: "",
                    transport: "",
                    label: [],
                    address: "",
                    main: "",
                });
            }
            for (let i = 0; i < this.addform.list.length; i++) {
                this.addform.list[i].index = i + 1;
            }
        },
        submitFormClose(formName) {
            if(this.addform.phone.length>0){
                if(!this.$common.checkPhone(this.addform.phone)){
                    this.$notify({
                        message: "号码不正确",
                        type: "error",
                        duration: 1000,
                    });
                    return;
                }
            }
            for(let i in this.addform.list){
                let con = this.addform.list[i];
                if(con.name!=null&&con.name.length>0){
                    if(!this.$common.checkPhone(con.phone)){
                        this.$notify({
                            message: con.name+"号码不正确",
                            type: "error",
                            duration: 1000,
                        });
                        return;
                    }
                }
            }
            
            let _this = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var contacts = [];
                    this.addform.list.map((item) => {
                        if (item.name) {
                            let cc = {
                                address:item.address,
                                index:item.index,
                                district:item.district,
                                main:item.main?1:0,
                                name:item.name,
                                phone:item.phone,
                                qq:item.qq,
                                tel:item.tel,
                                wechat:item.wechat,
                            } 
                            if(typeof(item.transport)=='object'){
                                cc.transport=item.transport.label;
                                cc.transportId=item.transport.id;
                            }else{

                                cc.transport=item.transport;
                                cc.transportId="";
                            }
                            contacts.push(cc);
                        }
                    });
                    this.addform.contacts = JSON.stringify(contacts);
                    let arr = [];
                    this.addform.workAddressList.forEach(e=>{
                        if(e.label||e.address){
                            arr.push(e);
                        }
                    })
                    this.addform.workAddress = JSON.stringify(arr);
                    this.$api.customeraddCustomer(this.addform).then((res) => {
                        if (res.data.code == 1) {
                            _this.$notify({
                                message: "添加成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    _this.addform = {
                                        cnumber:"",
                                        cname: "",
                                        category: "",
                                        phone: "",
                                        rank: "",
                                        signdate: "",
                                        start: "",
                                        end: "",
                                        beginBill: 0,
                                        company: "",
                                        saleName: "",
                                        username: "",
                                        password: "",
                                        valid: "0",
                                        invoice: "",
                                        taxIdentification: "",
                                        address: "",
                                        invphone: "",
                                        bankname: "",
                                        bankaccountnumber: "",
                                        list: [
                                            {
                                                index: 1,
                                                name: "",
                                                tel: "",
                                                phone: "",
                                                qq: "",
                                                wechat: "",
                                                transport: "",
                                                label: [],
                                                address: "",
                                                main: "",
                                            },
                                        ],
                                        workAddressList:[],
                                        contacts: "",
                                        remark: "",
                                    };
                                },
                            });
                        }
                        this.$emit("close");
                    });
                } else {
                    this.$notify({
                        message: "请填写正确的内容",
                        type: "warning",
                        duration: 1000,
                    });
                    return false;
                }
            });
        },
        mainContact(row) {
            if (row.main) {
                this.addform.list.map((item) => {
                    if (item.index === row.index) {
                        item.main = 1;
                    } else {
                        item.main = 0;
                    }
                });
            } else {
                this.addform.list.map((item) => {
                    if (item.index === row.index) {
                        item.main = 0;
                    }
                });
            }
        },
        dataPick() {
            this.addform.start = this.addform.signdate[0];
            this.addform.end = this.addform.signdate[1];
        },
        setAccount() {
            this.addform.username = this.addform.phone;
        },
    },
};
</script>